var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpportunity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60823",
    "data-name": "Group 60823",
    transform: "translate(-12702 -12933)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_472",
    "data-name": "Ellipse 472",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(12702 12933)",
    fill: "#fe6997",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_473",
    "data-name": "Ellipse 473",
    cx: 42,
    cy: 42,
    r: 42,
    transform: "translate(12710 12941)",
    fill: "#fe6997"
  }), /*#__PURE__*/React.createElement("g", {
    id: "d5ac3091cdd5614ed41f8fea2c56b3b6",
    transform: "translate(12728.473 12959.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24380",
    "data-name": "Path 24380",
    d: "M46.8,43.122l-3.336,3.336a.872.872,0,0,1-1.228,0l-9.849-9.851a.862.862,0,0,1,0-1.225l.879-.88-1.834-1.837-.366.366a.6.6,0,0,1-.85,0l-1-1.009a17.987,17.987,0,1,1,3.108-3.2l1.053,1.05a.6.6,0,0,1,0,.849l-.363.363L34.026,32.1l.819.822.88-.879a.868.868,0,0,1,1.228,0l9.206,9.2.643.644a.866.866,0,0,1,0,1.228ZM28.394,7.619a14.655,14.655,0,1,0,0,20.727,14.653,14.653,0,0,0,0-20.727Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60824",
    "data-name": "Group 60824",
    transform: "translate(9.365 16.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24381",
    "data-name": "Path 24381",
    d: "M203.87,363v4.087a.371.371,0,0,1-.37.37h-2.11a.371.371,0,0,1-.37-.37V363a.371.371,0,0,1,.37-.37h2.11A.371.371,0,0,1,203.87,363Zm8.243-2.092H210a.37.37,0,0,0-.368.37v5.809a.369.369,0,0,0,.368.37h2.11a.371.371,0,0,0,.37-.37V361.28A.372.372,0,0,0,212.113,360.91Zm-4.307-1.855H205.7a.369.369,0,0,0-.368.37v7.664a.369.369,0,0,0,.368.37h2.11a.37.37,0,0,0,.37-.37v-7.664A.37.37,0,0,0,207.806,359.055Zm8.612-1.788H214.31a.37.37,0,0,0-.37.37v9.452a.37.37,0,0,0,.37.37h2.108a.37.37,0,0,0,.37-.37v-9.452A.37.37,0,0,0,216.418,357.267Z",
    transform: "translate(-201.021 -357.267)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_24382",
    "data-name": "Path 24382",
    d: "M220.067,181.514l-6.16,1.688c-.2.052-.238.214-.094.358l1.625,1.628-3.394,3.393a.369.369,0,0,1-.522,0l-3.254-3.252a.369.369,0,0,0-.522,0l-5.439,5.438a.371.371,0,0,0,0,.523l.654.653a.369.369,0,0,0,.522,0l4.263-4.261a.369.369,0,0,1,.522,0l3.254,3.252a.368.368,0,0,0,.522,0l4.57-4.571,1.544,1.544a.2.2,0,0,0,.368-.093l1.794-6.044c.058-.2-.056-.31-.253-.256Z",
    transform: "translate(-192.778 -173.045)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpportunity);
export default __webpack_public_path__ + "static/media/opportunity.648ca93ce4156685285ade0574366c18.svg";
export { ForwardRef as ReactComponent };